<template>
  <section class="call-us">
    <div class="container">
      <div class="content">
        <router-link class="link" to="/contactUs">اتصل بنا </router-link>
        <p>يمكنك الاتصال بنا للاستفسار عن معلومة و سيتم الرد عليكم</p>
        <a class="whatsapp" href="https://wa.me/201065740616" target="_blank">
          <img src="../../content/imgs/whats.png" alt="" />
          <p>1215454551 002 +</p>
        </a>
      </div>
    </div>
  </section>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped></style>
